import { useLang, track } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/Editorial";
import { BSPORT } from "@/data/config";

// Shared final CTA band (Onyx background, Petal type).
export function CTABand() {
  const { t } = useLang();
  return (
    <section className="bg-onyx text-petal" data-testid="cta-band">
      <div className="mx-auto max-w-[1600px] px-6 py-28 md:px-12 md:py-40">
        <div className="grid items-end gap-12 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <SectionLabel light>Contrôle · Ligne · Force</SectionLabel>
            <Reveal>
              <h2 className="mt-8 font-serif text-6xl leading-[0.95] md:text-8xl">{t.home.finalTitle}</h2>
            </Reveal>
            <p className="mt-6 font-serif text-3xl italic text-blush">{t.home.finalBody}</p>
          </div>
          <div className="flex flex-col gap-4 lg:col-span-4 lg:items-end">
            <a
              href={BSPORT.INTRO_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("intro_offer_click", { source: "cta-band" })}
              className="label border border-petal bg-petal px-10 py-5 text-center text-onyx transition-colors duration-500 hover:bg-transparent hover:text-petal"
              data-testid="ctaband-intro"
            >
              {t.common.startIntro}
            </a>
            <a
              href={BSPORT.SCHEDULE_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("view_schedule_click", { source: "cta-band" })}
              className="label border border-petal/40 px-10 py-5 text-center text-petal transition-colors duration-500 hover:border-petal"
              data-testid="ctaband-schedule"
            >
              {t.common.viewSchedule}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

// Shared page header for interior pages.
export function PageHead({ label, title, lead, children }) {
  return (
    <header className="border-b border-onyx/10 bg-petal pt-36 md:pt-44">
      <div className="mx-auto max-w-[1600px] px-6 pb-16 md:px-12 md:pb-24">
        <SectionLabel>{label}</SectionLabel>
        <Reveal>
          <h1 className="mt-8 max-w-4xl font-serif text-6xl leading-[0.95] tracking-tight md:text-8xl">{title}</h1>
        </Reveal>
        {lead && <p className="mt-8 max-w-2xl font-sans text-lg leading-relaxed text-onyx/70">{lead}</p>}
        {children}
      </div>
    </header>
  );
}
